export default {
  xeroAccounts: [],
  xeroAccount: undefined,
};
